export default __webpack_public_path__ + "static/media/tenPercentageThreshold.af0f99c7.svg";